import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';

import { cls } from '@/utils/cls';

const badgeVariants = cva(
  'aria-invalid:ring-red-500/20  aria-invalid:border-red-500    inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden whitespace-nowrap rounded-md border border-neutral-200 px-2 py-0.5 text-xs font-medium transition-[color,box-shadow] focus-visible:border-neutral-950 focus-visible:ring focus-visible:ring-neutral-950/50    [&>svg]:pointer-events-none [&>svg]:size-3',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-neutral-900 text-neutral-50   [a&]:hover:bg-neutral-900/90 ',
        secondary:
          'border-transparent bg-neutral-100 text-neutral-900   [a&]:hover:bg-neutral-100/90 ',
        destructive:
          'border-transparent bg-red-500 text-white focus-visible:ring-red-500/20       [a&]:hover:bg-red-500/90 ',
        outline:
          'text-neutral-950  [a&]:hover:bg-neutral-100 [a&]:hover:text-neutral-900  ',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp: React.ElementType = asChild ? Slot : 'span';

  return (
    <Comp
      data-slot="badge"
      className={cls(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
